<template>
    <div class="OinCardPage">
        <navigation-bar Close/>
        <div class="tabs">
            <div @click="toSlide(0)" :class="{active : tabNum===0}">
                內容
            </div>
            <div @click="toSlide(1)" :class="{active : tabNum===1}">
                特約店
            </div>
            <div @click="toSlide(2)" :class="{active : tabNum===2}">
                紀錄
            </div>
        </div>

        <div class="main">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide>
                    <div class="swipe-content">
                        <div class="swipe-con card-detail">

                            <div class="coupon-top">
                                <div class="top_card_img">
                                    <img :src="cardPageData.imagePath" :class="{'not-renewed': cardPageData.isEnable === 0}">
                                </div>
                                <div class="text-center mb-3"><span v-if="cardPageData.isEnable">目前還有 </span><span class="red">{{cardPageData.diffDayString}}</span>
                                </div>
                                <div class="text-center mt-2 mb-4" v-if="cardPageData.diffDay <= 7 && false">
                                    <!--                  <el-button type="warning" @click="$router.push({ name: 'CardRenew'})" round>-->
                                    <el-button type="warning" @click="alertDialog()" round>
                                        我要續卡
                                    </el-button>
                                </div>
                            </div>

                            <div class="coupon-body">
                                <!--<div class="top-text">
                                    <img src="@/assets/images/pig.svg">
                                    <div class="con">
                                        <div>本週：已為您省下 <span><b
                                                class="red">{{$public.numberFormat(cardPageData.weekDiscount)}}</b>元</span></div>
                                        <div>累積：已為您省下 <span><b
                                                class="red">{{$public.numberFormat(cardPageData.allDiscount)}}</b>元</span></div>
                                    </div>
                                </div>-->
                                <div class="shadow-line mr-0 ml-0"></div>

                                <div class="container pb-4">

                                    <h4>{{cardPageData.name}}</h4>

                                    <div class="UseBranch">
                                        <h6>活動檔期</h6>
                                        <div class="date">
                                            {{cardPageData.startAt}}~{{cardPageData.endAt}} 止
                                        </div>
                                    </div>
                                    <el-divider></el-divider>

                                    <div v-show="isShowContent(cardPageData.content)">
                                        <h6 class="mt-3">活動說明</h6>
                                        <p>{{cardPageData.content}}</p>
                                    </div>
                                    <div v-show="isShowNotice(cardPageData.contentPrecautionsList)">
                                        <h6 class="mt-4">注意事項</h6>
                                        <ol>
                                            <li v-for="(item, index) in cardPageData.contentPrecautionsList"
                                                :key="'contentPrecautions' + index">{{item}}
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swipe-content">
                        <div class="swipe-con">
                            <div style="margin: 0 20px" class="pb-4">
                                <div class="no-data" v-if="cardStoreList.length===0">
                                    <img src="@/assets/images/empty.svg">
                                    <p>OH！目前空空的</p>
                                </div>
                                <div class="list-style" v-for="(item, index) in cardStoreList" :key="'cardStore' + index">
                                    <div class=" mr-3" @click="goStoreInfo(item)">
                                        <el-image :src="item.storeImage" class="pic2" fit="cover"></el-image>
                                        <div class="distance">
                                            <img v-if="item.distanceStr !== ''" src="@/assets/images/location_blue_line.svg">
                                            {{item.distanceStr}}
                                        </div>
                                    </div>

                                    <div class="content">
                                      <h2><span @click="goStoreInfo(item)">{{item.brandName}}</span><span class="ml-3" @click="goStoreInfo(item)">{{item.storeName}}</span>
                                            <img v-if="item.discountType === 2 && item.discountPrice === maxDiscountPrice"
                                                 src="@/assets/images/brand-type1.svg" alt="提供最高優惠" class="brand-type">
                                            <img v-if="item.discountType === 1 && item.discountOff === maxDiscountOff"
                                                 src="@/assets/images/brand-type2.svg" alt="提供最高折抵：全單最高折扣>全單最高折價>抵用串串幣" class="brand-type">
                                            <img v-if="item.storeId === maxUseStoreId" src="@/assets/images/brand-type3.svg"
                                                 alt="熱門店家：最多人消費的店家" class="brand-type">
                                        </h2>
                                        <div class="phone-btn">
                                            <a @click="$public.callTel(item.storeTel)" v-if="item.storeTel !== ''">
                                                <img src="@/assets/images/phone.svg">
                                                <span>{{item.storeTel}}</span>
                                            </a>
                                        </div>
                                        <div class="location-btn">
                                            <a @click="onClickLocationBtn(item.lat, item.lng, item.googleMapUrl)"
                                               v-if="item.storeAddress !== ''">
                                                <img src="@/assets/images/location_blue.svg">
                                                <span>{{item.storeAddress}}</span>
                                            </a>
                                        </div>
                                        <!--todo 外送資訊-->
                                        <div class="takeout-list single mt-2" @click="isOpen(index)" v-if="false">
                                            <div class="title">
                                                <i class="el-icon-goods"/>外送：
                                            </div>
                                            <div class="con">
                                                0-3km 滿$500 免運<br>
                                                3km以上-4km $50<br>
                                                5km以上-7km $100<br>
                                            </div>
                                            <div class="icon-arrow">
                                                <i class="el-icon-caret-bottom"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="offer-status" v-if="false">
                                        <div class="block">
                                            <span>咖啡1+1</span>
                                            <span>$0</span>
                                        </div>
                                        <div class="block">
                                            <span>15:00</span>
                                            <span>-10%</span>
                                        </div>
                                        <div class="block">
                                            <span>15:30</span>
                                            <span>-$50</span>
                                        </div>
                                        <div class="block">
                                            <span>16:00</span>
                                            <span>-10%</span>
                                        </div>
                                        <div class="block">
                                            <span>16:30</span>
                                            <span>-$50</span>
                                        </div>
                                        <div class="block">
                                            <span>17:00</span>
                                            <span>-10%</span>
                                        </div>
                                        <div class="block">
                                            <span>17:30</span>
                                            <span>-$50</span>
                                        </div>
                                        <div class="block">
                                            <span>18:00</span>
                                            <span>-10%</span>
                                        </div>
                                    </div>
                                    <div class="coin">
                                        <div>
                                            <div v-if="false">
                                                <img src="@/assets/images/coin.svg">
                                                接受全額抵用 串串幣
                                            </div>
                                        </div>
                                        <div v-if="item.discountContent!=''">
                                            <img src="@/assets/images/tag.svg" class="tag">
                                            {{item.discountContent}}
                                        </div>
                                    </div>
                                </div>
                                <infinite-loading v-if="isStore" spinner="waveDots" @infinite="setupStoreListScroll">
                                    <div slot="no-more">沒有更多資料</div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swipe-content">
                        <div class="swipe-con">
                            <div style="margin: 0 20px" class="pb-4">
                                <ul class="record_content card">
                                    <li v-for="(item, index) in cardRecordList" :key="'cardRecord' + index">
                                        <div class="content">
                                            <div class="left">
                                                <div class="info">
                                                    <div class="time">{{item.createdAt}}</div>
                                                    <div class="branch">LIFE LINK串門子</div>
                                                    <div class="branch">{{item.storeName}}</div>
                                                    <div class="title">{{item.cardListName}}</div>
                                                </div>
                                                <div class="mt-2" v-if="item.type !== 1">
                                                    <span v-if="item.type === 3">累積：</span>已為您省下
                                                    <div class="float-right">
                                                        <span class="red">{{$public.numberFormat(item.discount)}}</span> 元
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!--todo status 有 enable(開卡)、invalid(已失效)-->
                                                <div class="status" :class="setStatusClass(item.type)">{{item.status}}</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <infinite-loading v-if="isRecord" spinner="waveDots" @infinite="setupRecordListScroll">
                                    <div slot="no-more">沒有更多資料</div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <comm-dialog :value="isShowDialog" :outerContent="dialogMsg" :isCancel="false"
                     @result="onDialogResult"></comm-dialog>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import CommDialog from '@/components/CommDialog.vue';
    let vm = null;
    export default {
        name: "OinCardPage",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            Swiper,
            SwiperSlide,
            CommDialog
        },
        data() {
            return {
                dataToken: this.isWeb? (this.dataTokenWeb.dataToken ?? "") : (this.$route.query.dataToken ?? ""),
                dataObject: {},
                oinCardPageData:{
                    cardListId: this.isWeb? parseInt(this.dataTokenWeb.cardListId || 0) : parseInt(this.$route.query.cardListId || 0),
                    cardUserId: this.isWeb? parseInt(this.dataTokenWeb.cardUserId || 0) :parseInt(this.$route.query.cardUserId || 0),
                    activeCategory: this.isWeb? this.dataTokenWeb.activeCategory :this.$route.query.activeCategory,
                },
                //目前索引值
                tabNum: 0,
                //swiper套件設定
                swiperOptions: {
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                        },
                    },
                    breakpoints: {
                        //電腦版不給左右滑動
                        1024: {
                            noSwipingSelector: '.swiper-slide',
                            //autoHeight: true,
                            slideSpeed: 0,
                            speed: 0,
                        }
                    },
                },

                isLoading: false,
                isShowDialog: false,
                dialogMsg: '',
                activeTab: '',

                cardPageData: {},

                cardStoreOffset: 0,
                cardStorePageSize: 10,
                cardStoreList: [],
                infiniteLoadingUserStoreState: '',
                isStore: false,
                longitude: 0,
                latitude: 0,
                maxUseStoreId: 0,
                maxDiscountOff: 0,
                maxDiscountPrice: 0,

                cardRecordOffset: 0,
                cardRecordPageSize: 10,
                cardRecordList: [],
                infiniteLoadingUserRecordState: '',
                isRecord: false,

            }
        },
        created() {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
            } catch (e) {
                this.dataObject = {}
            }

            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (this.dataObject.usedType === 'OinCardPage' && this.oinCardPageData.cardListId === 0 && this.oinCardPageData.cardUserId === 0 && this.dataObject.cardListId > 0) {
                    this.oinCardPageData.cardListId = this.dataObject.cardListId
                    this.oinCardPageData.cardUserId = this.dataObject.cardUserId
                    this.oinCardPageData.activeCategory = this.dataObject.activeCategory
                }
            } catch (e) {
                this.dataObject = {}
            }
            vm = this;
            let self = this
            self.activeTab = 0;
            self.setupPageData();

            self.$sqlite.delete('delete from gift_read  where gift_id = ? and type = ? ', [self.oinCardPageData.cardListId, self.oinCardPageData.activeCategory]);

            self.$sqlite.query("select id from gift_read where type = ?", [self.oinCardPageData.activeCategory], function (resultSet) {
                if (resultSet.rows.length === 0) {
                    self.$emit("triggerEvent", {
                        event: 'reduceIsOinCardReadCount'
                    })
                }
            })
        },
        activated () {

        },
        methods: {
            showDialog(msg) {
                this.dialogMsg = msg;
                this.isShowDialog = true;
            },
            onDialogResult() {
                this.isShowDialog = false;
            },
            clearData() {
                this.cardPageData = {};

                this.cardStoreOffset = 0;
                this.cardStoreList = [];

                this.cardRecordOffset = 0;
                this.cardRecordList = [];
            },
            changeActiveTab(tab) {
                if (this.activeTab === tab) {
                    return
                }

                this.activeTab = tab;

                this.clearData();

                if (this.activeTab === 0) {
                    this.setupPageData();
                } else if (this.activeTab === 1) {
                    if (this.infiniteLoadingUserStoreState !== '') {
                        this.infiniteLoadingUserStoreState.reset();
                    } else {
                        this.isStore = true
                    }
                } else if (this.activeTab === 2) {
                    if (this.infiniteLoadingUserRecordState !== '') {
                        this.infiniteLoadingUserRecordState.reset();
                    } else {
                        this.isRecord = true
                    }
                }
            },
            setupPageData() {
                this.isLoading = true;
                let isAddOpenCount = false
                if (!sessionStorage.getItem('isOinCardVisited')) {
                    isAddOpenCount = true
                    sessionStorage.setItem('isOinCardVisited', 'yes');
                }

                this.$http.fetchWithAuthEncrypt`GetMyOinCardInfo${{
                    "id": this.oinCardPageData.cardUserId,
                    'isAddOpenCount': isAddOpenCount,
                }} ${json => {
                    if (json.status) {
                        this.cardPageData = json.data
                    } else {
                        this.showDialog('抱歉：' + json.message);
                    }
                    this.isLoading = false;
                }}`;
            },
            setupStoreListScroll($state) {
                let self = this
                this.isLoading = true;
                this.infiniteLoadingUserStoreState = $state

                if (this.cardStoreOffset === 0) {

                    this.getStoreIconInfo();

                    let onSuccess = function (position) {
                        self.longitude = position.coords.longitude;
                        self.latitude = position.coords.latitude;
                        self.setupStoreList();
                    };

                    let onError = function (error) {
                        self.longitude = 0;
                        self.latitude = 0;
                        self.setupStoreList();
                        self.$public.showNotify("code: " + error.code + ", message: " + error.message + "。無法定位GPS", false, 3000)
                    };

                    self.$public.getGpsLocation(onSuccess, onError);

                } else {
                    self.setupStoreList()
                }
            },
            setupStoreList() {
                this.isLoading = true;
                this.$http.fetchWithAuthEncrypt`GetMyOinCardStoreList${{
                    "id": this.oinCardPageData.cardListId,
                    "offset": this.cardStoreOffset,
                    "lng": this.longitude,
                    "lat": this.latitude,
                }} ${json => {
                    if (json.status) {
                        if (json.data.length >= this.cardStorePageSize) {
                            this.cardStoreOffset++;
                            this.cardStoreList.push(...json.data);
                            this.infiniteLoadingUserStoreState.loaded();
                        } else {
                            this.cardStoreOffset++;
                            this.cardStoreList.push(...json.data);
                            this.infiniteLoadingUserStoreState.complete();
                        }
                    } else {
                        this.infiniteLoadingUserStoreState.complete();
                        this.showDialog('抱歉：' + json.message);
                    }
                    this.isLoading = false;
                }}`;
            },
            setupRecordListScroll($state) {
                this.isLoading = true;
                this.infiniteLoadingUserRecordState = $state
                this.$http.fetchWithAuthEncrypt`GetMyOinCardRecordList${{
                    "id": this.oinCardPageData.cardUserId,
                    "offset": this.cardRecordOffset
                }} ${json => {
                    if (json.status) {
                        if (json.data.length >= this.cardRecordPageSize) {
                            this.cardRecordOffset++;
                            this.cardRecordList.push(...json.data);
                            $state.loaded();
                        } else {
                            this.cardRecordOffset++;
                            this.cardRecordList.push(...json.data);
                            $state.complete();
                        }
                    } else {
                        $state.complete();
                        this.showDialog('抱歉：' + json.message);
                    }
                    this.isLoading = false;
                }}`;
            },
            setStatusClass(statusId) {
                switch (statusId) {
                    case  1:
                        return 'enable';
                    case  2:
                        return 'used';
                    case  3:
                        return 'invalid';
                }
            },
            getStoreIconInfo() {
                this.$http.fetchWithAuthEncrypt`GetOinCardStoreIconInfo${{
                    "id": this.oinCardPageData.cardListId,
                }} ${json => {
                    if (json.status) {
                        this.maxUseStoreId = json.data.maxUseStoreId
                        this.maxDiscountOff = json.data.maxDiscountOff
                        this.maxDiscountPrice = json.data.maxDiscountPrice
                    } else {
                        this.showDialog('抱歉：' + json.message);
                    }
                }}`;
            },
            alertDialog() {
                this.dialogMsg = '此功能尚未開放';
                this.isShowDialog = true;
            },
            isOpen(id) {//外送詳細開合
                document.getElementsByClassName('takeout-list')[id].classList.toggle("open")
            },
            /** 點擊地點按鈕 */
            onClickLocationBtn: function (lat = 0, lng = 0, googleMapUrl = null) {
                if (this.$public.notNull(googleMapUrl) && googleMapUrl !== '') {
                    let param = this.$public.analyzeGoogleMapUrl(googleMapUrl);
                    if (this.$public.notNull(param)) {
                        //開啓地圖
                        if (this.$public.notNull(param.googleMapStoreInfoData) && param.googleMapLat > 0 && param.googleMapLng > 0) {
                            //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                            this.$public.openMap(param.googleMapLat, param.googleMapLng, param.googleMapStoreInfoData);
                        } else {
                            this.$public.openMap(param.googleMapLat, param.googleMapLng);
                        }
                    }

                } else if (lat !== 0 && lng !== 0) {
                    this.$public.openMap(lat, lng);
                }
            },
            toSlide(index) {
                this.$refs.mySwiper.$swiper.slideTo(index)
            },
            tabNumber(index) {
                this.tabNum=index
                this.changeActiveTab(index)
            },
            goStoreInfo(item) {
              if(item.storeId > 0 && !this.isWeb) {
                this.$store.commit("savePageSnapshot",{ routeName: "oinCardPage", variable: this.oinCardPageData});
                this.$router.push({name: 'StoreInfo', query:{id: item.storeId}})
              }
            },

            /** 是否顯示活動說明 */
            isShowContent: function(content) {
                let result = this.$public.notNull(content) && (content !== '');
                return result;
            },

            /** 是否顯示注意事項 */
            isShowNotice: function(content) {
                let result = this.$public.notNull(content) && (content.length > 0);
                return result;
            },
        }
    }
</script>

<style lang="less" scoped src="../../less/gift.less"/>